import { useIsMutating, useMutation } from '@tanstack/react-query';
import CarrierService from '../../services/settings/ppoints/CarrierService';
import { useAppSelector } from '../../redux/hooks';

export const useCarrierService = () => {
    const ecoms = useAppSelector((state) => state.ecoms);

    const keys = {
        createKey: 'carrier-service-create-mutation',
        deleteKey: 'carrier-service-delete-mutation',
    };

    const createCarrierServiceMutation = useMutation({
        mutationKey: [keys.createKey],
        mutationFn: async () => {
            if (!ecoms.id) return Promise.reject();
            return await CarrierService.createService(ecoms.id);
        },
    });
    const deleteCarrierServiceMutation = useMutation({
        mutationKey: [keys.deleteKey],
        mutationFn: async () => {
            if (!ecoms.id) return Promise.reject();
            return await CarrierService.deleteService(ecoms.id);
        },
    });

    const mutating = {
        [keys.createKey]: useIsMutating([keys.createKey]),
        [keys.deleteKey]: useIsMutating([keys.deleteKey]),
    };

    return {
        createCarrierServiceMutation,
        deleteCarrierServiceMutation,
        isLoading: mutating[keys.createKey] > 0 || mutating[keys.deleteKey] > 0,
    };
};
